export const lerp = (x, y, a) => x * (1 - a) + y * a;

export const clamp = (number, min, max) => Math.max(min, Math.min(number, max));
